const gamesObj = [
  {
    "awayTeam": {
      "abbreviation": "BAL",
      "id": "10400325-48de-3d6a-be29-8f829437f4c8",
      "logo": "https://static.www.nfl.com/f_png,w_100,h_100,c_fit/league/api/clubs/logos/BAL",
      "name": "Baltimore Ravens",
      "primaryColorDark": "#9E7C0C",
      "primaryColorLight": "#241773"
    },
    "canListen": false,
    "canWatch": true,
    "gameStartDateFormatted": "FRI SEPT 6",
    "gameStartTime": "2024-09-06T00:20:00Z",
    "gameStartTimeFormatted": "7:00 PM PST",
    "homeTeam": {
      "abbreviation": "KC",
      "id": "10402310-a47e-10ea-7442-16b633633637",
      "logo": "https://static.www.nfl.com/f_png,w_100,h_100,c_fit/league/api/clubs/logos/KC",
      "name": "Kansas City Chiefs",
      "primaryColorDark": "#E31837",
      "primaryColorLight": "#E31837"
    },
    "id": "7d3e8f84-1312-11ef-afd1-646009f18b2e",
    "isGameInRedZoneWindow": false,
    "isOutOfMarket": false,
    "live": true
  },
  {
    "awayTeam": {
      "abbreviation": "GB",
      "id": "10401800-ab22-323d-721a-cee4713c4c2d",
      "logo": "https://static.www.nfl.com/f_png,w_100,h_100,c_fit/league/api/clubs/logos/GB",
      "name": "Green Bay Packers",
      "primaryColorDark": "#FFB612",
      "primaryColorLight": "#203731"
    },
    "canListen": true,
    "canWatch": true,
    "gameStartDateFormatted": "SAT SEPT 7",
    "gameStartTime": "2024-09-07T00:15:00Z",
    "gameStartTimeFormatted": "3:00 PM PST",
    "homeTeam": {
      "abbreviation": "PHI",
      "id": "10403700-b939-3cbd-3d16-24d4d6742fa2",
      "logo": "https://static.www.nfl.com/f_png,w_100,h_100,c_fit/league/api/clubs/logos/PHI",
      "name": "Philadelphia Eagles",
      "primaryColorDark": "#A5ACAF",
      "primaryColorLight": "#004C54"
    },
    "id": "7d4019ca-1312-11ef-afd1-646009f18b2e",
    "isGameInRedZoneWindow": false,
    "isOutOfMarket": false,
    "live": false
  },
  {
    "awayTeam": {
      "abbreviation": "PIT",
      "id": "10403900-8251-6892-d81c-4348525c2d47",
      "logo": "https://static.www.nfl.com/f_png,w_100,h_100,c_fit/league/api/clubs/logos/PIT",
      "name": "Pittsburgh Steelers",
      "primaryColorDark": "#FFB612",
      "primaryColorLight": "#101820"
    },
    "canListen": false,
    "canWatch": true,
    "gameStartDateFormatted": "SUN SEPT 8",
    "gameStartTime": "2024-09-08T17:00:00Z",
    "gameStartTimeFormatted": "5:00 PM PST",
    "homeTeam": {
      "abbreviation": "ATL",
      "id": "10400200-f401-4e53-5175-0974e4f16cf7",
      "logo": "https://static.www.nfl.com/f_png,w_100,h_100,c_fit/league/api/clubs/logos/ATL",
      "name": "Atlanta Falcons",
      "primaryColorDark": "#A71930",
      "primaryColorLight": "#000000"
    },
    "id": "7d401ff8-1312-11ef-afd1-646009f18b2e",
    "isGameInRedZoneWindow": true,
    "isOutOfMarket": false,
    "live": false
  },
  {
    "awayTeam": {
      "abbreviation": "ARI",
      "id": "10403800-517c-7b8c-65a3-c61b95d86123",
      "logo": "https://static.www.nfl.com/f_png,w_100,h_100,c_fit/league/api/clubs/logos/ARI",
      "name": "Arizona Cardinals",
      "primaryColorDark": "#97233F",
      "primaryColorLight": "#000000"
    },
    "canListen": true,
    "canWatch": false,
    "gameStartDateFormatted": "SUN SEPT 8",
    "gameStartTime": "2024-09-08T17:00:00Z",
    "gameStartTimeFormatted": "5:00 PM PST",
    "homeTeam": {
      "abbreviation": "BUF",
      "id": "10400610-c40e-a673-1743-2ce2a5d5d731",
      "logo": "https://static.www.nfl.com/f_png,w_100,h_100,c_fit/league/api/clubs/logos/BUF",
      "name": "Buffalo Bills",
      "primaryColorDark": "#C60C30",
      "primaryColorLight": "#00338D"
    },
    "id": "7d40236a-1312-11ef-afd1-646009f18b2e",
    "isGameInRedZoneWindow": true,
    "isOutOfMarket": true,
    "live": false
  },
  {
    "awayTeam": {
      "abbreviation": "TEN",
      "id": "10402100-447f-396e-8149-0a434ffb2f23",
      "logo": "https://static.www.nfl.com/f_png,w_100,h_100,c_fit/league/api/clubs/logos/TEN",
      "name": "Tennessee Titans",
      "primaryColorDark": "#4B92DB",
      "primaryColorLight": "#0C2340"
    },
    "canListen": false,
    "canWatch": false,
    "gameStartDateFormatted": "SUN SEPT 8",
    "gameStartTime": "2024-09-08T17:00:00Z",
    "gameStartTimeFormatted": "5:00 PM PST",
    "homeTeam": {
      "abbreviation": "CHI",
      "id": "10400810-db30-43d6-221c-620006f3ca19",
      "logo": "https://static.www.nfl.com/f_png,w_100,h_100,c_fit/league/api/clubs/logos/CHI",
      "name": "Chicago Bears",
      "primaryColorDark": "#C83803",
      "primaryColorLight": "#0B162A"
    },
    "id": "7d4025fa-1312-11ef-afd1-646009f18b2e",
    "isGameInRedZoneWindow": false,
    "isOutOfMarket": true,
    "live": false
  },
  {
    "awayTeam": {
      "abbreviation": "NE",
      "id": "10403200-69ab-9ea6-5af5-e240fbc08bea",
      "logo": "https://static.www.nfl.com/f_png,w_100,h_100,c_fit/league/api/clubs/logos/NE",
      "name": "New England Patriots",
      "primaryColorDark": "#C60C30",
      "primaryColorLight": "#002244"
    },
    "canListen": false,
    "canWatch": true,
    "gameStartDateFormatted": "SUN SEPT 8",
    "gameStartTime": "2024-09-08T17:00:00Z",
    "gameStartTimeFormatted": "5:00 PM PST",
    "homeTeam": {
      "abbreviation": "CIN",
      "id": "10400920-57c1-7656-e77e-1af3d900483e",
      "logo": "https://static.www.nfl.com/f_png,w_100,h_100,c_fit/league/api/clubs/logos/CIN",
      "name": "Cincinnati Bengals",
      "primaryColorDark": "#FB4F14",
      "primaryColorLight": "#000000"
    },
    "id": "7d402876-1312-11ef-afd1-646009f18b2e",
    "isGameInRedZoneWindow": false,
    "isOutOfMarket": false,
    "live": false
  }
]

export const games = {
  "currentWeek": "Week 1",
  "games": JSON.stringify(gamesObj),
}
